var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.097,
    height: 19.024,
    viewBox: "0 0 18.097 19.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_957",
    "data-name": "Caminho 957",
    d: "M4676.246,7487h-7.388l-8.833,9.512,8.833,8.512h7.388l-8.191-8.512Z",
    transform: "translate(-4659.324 -7486.5)",
    fill: "rgba(212,175,55,0.9)",
    stroke: "rgba(212,175,55,0.9)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevContent);
export default __webpack_public_path__ + "static/media/prevContent.5b7e1f80c1f805238ea8bc39fcb3249b.svg";
export { ForwardRef as ReactComponent };